import { config } from './consts';

const prefixMaxLength = 4;
const prefixMinLength = 2;
const generatePrefix = (organization: string) => {
    let prefix = organization;

    if (prefix.length <= prefixMaxLength) {
        return prefix.toUpperCase();
    }

    prefix = prefix
        .toUpperCase()
        .replace(/\s/g, '')
        .replace(/[^A-Z]/g, '')
        .replace(/[AEIOU]/g, '')
        .replace(/([A-Z])(?=\1)/g, '')
        .substr(0, prefixMaxLength);

    if (prefix.length < prefixMinLength) {
        prefix = organization
            .toUpperCase()
            .replace(/\s/g, '')
            .replace(/[^A-Z]/g, '')
            .substr(0, prefixMaxLength);
    }

    return prefix;
};

export const prepareSignUpDate = (date: Record<string, any>) => {
    const clientname = date.email.split('@')[1];

    return {
        realname: `${date.firstname} ${date.lastname}`,
        email: date.email,
        password: date.password,
        language: 'en',
        vuln_prefix: generatePrefix(clientname),
        partner_uuid: config.partnerUUID,
        clientname
    };
};

export const signUp = async (payload: Record<string, any>) => {
    const response = await fetch(`${config.apiURL}/v2/registration`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        referrer: 'https://www.wallarm.com/',
        referrerPolicy: 'strict-origin-when-cross-origin',
        body: JSON.stringify(payload),
        method: 'POST',
        mode: 'cors',
        credentials: 'include'
    });

    const parsedRes = await response.json();
    return { [response.ok ? 'res' : 'err']: parsedRes.body || parsedRes };
};
